<mat-dialog-content>
  <p class="alert-dialog-message">
    {{ text }} </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button [matDialogClose]="">OK</button>
</mat-dialog-actions>
